module.exports = __webpack_public_path__ + "media/ru_ru_s1_Anya.34ecf4e6.oga";